import React from 'react';
import Preparing from '../../components/Preparing/Preparing';

const PhotowallPage = () => {
    return (
        <div>
            <div className='text-center mt-8 mb-8 text-2xl font-bold'>전광판포토월</div>
            <hr  className=' ml-28 mr-28'/>
            <Preparing/>
        </div>
    );
};

export default PhotowallPage;